import { useEffect } from 'react'
import { useContactStore } from '@/store/contact'
import { QRCodeViewer } from './QRCodeViewer'
import Image from 'next/image'

interface ContactQRCodeProps {
  size?: number
  className?: string
}

export function ContactQRCode({ size = 200, className }: ContactQRCodeProps) {
  const { qrContactInfo, fetchQrContactInfo } = useContactStore()

  useEffect(() => {
    if (!qrContactInfo) {
      fetchQrContactInfo()
    }
  }, [qrContactInfo, fetchQrContactInfo])

  if (qrContactInfo) {
    return <QRCodeViewer value={qrContactInfo} size={size} className={className} />
  }

  // Fallback to default image if no dynamic QR code is set
  return (
    <div className={className}>
       <Image
        src="/images/work_wechat_qrcode_mini.jpg"
        alt="WeChat QR Code"
        width={size}
        height={size}
        className="rounded-lg"
      />
    </div>
  )
}
